import React, { useContext, useState } from "react";
import "../../styles/dailyInsightsCard.css";
import { WebsiteContext } from "../../context/AppContext";
import ContentComponent from "../common/ContentComponent";
import { HiSparkles } from "react-icons/hi2";
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoCloseCircle } from "react-icons/io5";
import { LuRefreshCw } from "react-icons/lu";
import { motion, AnimatePresence } from "framer-motion";

const sampleInsights = [
  {
    quote: "True eloquence is not about speaking without hesitation, but articulating wisdom with profound resilience.",
    author: "Fluent Fable AI Mentor",
    word: "Eloquence",
    pos: "Noun",
    definition: "Fluent, graceful, and persuasive speaking or writing.",
    synonyms: ["Fluency", "Expressiveness", "Articulacy", "Poise"],
    antonyms: ["Hesitation", "Inarticulacy", "Awkwardness", "Mumbling"],
  },
  {
    quote: "An inquisitive mind is never stagnant; it consistently elucidates tricky language with relentless passion.",
    author: "Fluent Fable AI Mentor",
    word: "Inquisitive",
    pos: "Adjective",
    definition: "Having or showing an eager desire to learn and investigate.",
    synonyms: ["Curious", "Investigative", "Probing", "Inquiring"],
    antonyms: ["Indifferent", "Apathetic", "Passive", "Uninterested"],
  },
  {
    quote: "Clarity of expression eliminates ambiguity and connects hearts across different cultures.",
    author: "Fluent Fable AI Mentor",
    word: "Ambiguity",
    pos: "Noun",
    definition: "The state of being open to more than one interpretation; vagueness.",
    synonyms: ["Vagueness", "Obscurity", "Uncertainty", "Doubt"],
    antonyms: ["Clarity", "Certainty", "Precision", "Lucidity"],
  },
];

const DailyAiInsightsCard = () => {
  const { isMobileView, dark } = useContext(WebsiteContext);
  const [currentIndex, setCurrentIndex] = useState(0);

  const current = sampleInsights[currentIndex];

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % sampleInsights.length);
  };

  return (
    <div className={isMobileView ? "daily_insights_section_mobile" : "daily_insights_section"}>
      <div className="daily_insights_text_wrapper">
        <ContentComponent
          title={"Daily AI Insights: Learn Through Meaningful Quotes"}
          content={
            "Start each day with an inspiring quote. Fluent Fable AI automatically extracts key vocabulary, presenting instant synonyms and antonyms to naturally expand your active word bank."
          }
        />
      </div>

      <div className="ai_insight_card_wrapper">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -15 }}
            transition={{ duration: 0.3 }}
            className={`ai_insight_card ${dark ? "ai_insight_card_dark" : "ai_insight_card_light"}`}
          >
            {/* Card Header */}
            <div className="card_top_bar">
              <span className="card_chip">
                <HiSparkles size={14} /> Daily AI Insight
              </span>
              <span className="card_date">Today's Quote</span>
            </div>

            {/* Quote */}
            <div className="card_quote_box">
              <p className="card_quote_text">"{current.quote}"</p>
              <p className="card_quote_author">— {current.author}</p>
            </div>

            {/* Featured Vocabulary Word */}
            <div className="featured_word_box">
              <div className="featured_word_title">
                <span className="featured_word">{current.word}</span>
                <span className="featured_pos">{current.pos}</span>
              </div>
              <p className="featured_def">{current.definition}</p>
            </div>

            {/* Synonyms & Antonyms */}
            <div className="syn_ant_grid">
              <div className="syn_box">
                <div className="syn_label">
                  <IoCheckmarkCircle size={14} /> Synonyms
                </div>
                <div className="tags_wrap">
                  {current.synonyms.map((s, i) => (
                    <span key={i} className="syn_tag">
                      {s}
                    </span>
                  ))}
                </div>
              </div>

              <div className="ant_box">
                <div className="ant_label">
                  <IoCloseCircle size={14} /> Antonyms
                </div>
                <div className="tags_wrap">
                  {current.antonyms.map((a, i) => (
                    <span key={i} className="ant_tag">
                      {a}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Card Footer */}
            <div className="card_footer_bar">
              <span className="card_hint">Featured in Fluent Fable App</span>
              <button className="card_cycle_btn" onClick={handleNext} title="View another quote">
                <LuRefreshCw size={12} /> Next Quote
              </button>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default DailyAiInsightsCard;
